import React, {ReactNode} from "react";

export default function formatError({
  status,
  message,
  subMessage,
}: {
  status?: number;
  message?: string;
  subMessage?: string;
}): ReactNode {
  if (status === 404) {
    return (
      message || (
        <>
          This restaurant does not exist. Try{" "}
          <a href="https://eatclub.com">eatclub.com</a>
        </>
      )
    );
  }

  if (subMessage) {
    return `Oops, we had a problem loading ${subMessage}. Please refresh the page.`;
  }

  return message || "Ooops! Something went wrong";
}
